import GuestNewQuote from '../../views/GuestNewQuote';
import { OnlineGuestQuoteEstimate } from '../../views/index.view';

export default function route() {
  return [
    {
      path: accessRoute.GUEST_QUOTE_ESTIMATE.path,
      private: false,
      name: accessRoute.GUEST_QUOTE_ESTIMATE.name,
      key: accessRoute.GUEST_QUOTE_ESTIMATE.key,
      belongsToSidebar: false,
      icon: accessRoute.GUEST_QUOTE_ESTIMATE.icon,
      element: <OnlineGuestQuoteEstimate />,
    },
    {
        path: accessRoute.GUEST_NEW_QUOTE.path,
        private: false,
        name: 'Guest New Quote',
        key: accessRoute.GUEST_NEW_QUOTE.key,
        belongsToSidebar: false,
        icon: accessRoute.GUEST_NEW_QUOTE.icon,
        element: <GuestNewQuote />,
      },
  ];
}

export const accessRoute = {
  GUEST_QUOTE_ESTIMATE: {
    path: '/customer/wordpress-online-quote-estimate',
    name: 'Get Online Quote Estimate',
    key: 'terms',
    for: 'customer',
    icon: <em className="gg-financing"></em>,
  },
  GUEST_NEW_QUOTE: {
    path: '/customer/wordpress-guest-new-quote/:bookingId',
    name: 'Guest new quote',
    key: 'terms',
    for: 'customer',
    icon: <em className="gg-financing"></em>,
  },
};

export const getChildrenRoutes = () => {
  return route();
};
